import { Badge } from './ui'
import type { DeploymentStatus } from '../utils/deploymentRows'

/** A deployment's status: the worst of its apps (utils/deploymentRows). `fallback` is the app
 *  status shown when none of the known statuses applies. */
export default function DeploymentStatusBadge({ status, fallback }: { status: DeploymentStatus; fallback: string }) {
  switch (status) {
    case 'failed':
      return <Badge tone="red">Failed</Badge>
    case 'not_in_intune':
      return (
        <span title="An app of this deployment is no longer in Intune: it was deleted in the Intune admin center. Deploy publishes a new app; Remove drops the record.">
          <Badge tone="red">Not in Intune</Badge>
        </span>
      )
    case 'out_of_sync':
      return (
        <span title="An edit reached one app of this deployment but not the other. Open the deployment and choose Retry.">
          <Badge tone="amber">Out of sync</Badge>
        </span>
      )
    case 'pending':
      return <Badge tone="amber">Pending</Badge>
    case 'not_assigned':
      return <Badge tone="slate">Not assigned</Badge>
    case 'assigned':
      return <Badge tone="green">Assigned</Badge>
    default:
      return <Badge tone="slate">{fallback.charAt(0).toUpperCase() + fallback.slice(1)}</Badge>
  }
}
